export const getPropertyTitle = (titles, type, isPlural = false) => {
  let result = titles.Hotel;
  switch (type.toLowerCase()) {
    case "hotel":
      result = isPlural ? titles.Hotels : titles.Hotel;
      break;
    case "apartment":
      result = isPlural ? titles.Apartments : titles.Apartment;
      break;
    case "hostel":
      result = isPlural ? titles.Hostels : titles.Hostel;
      break;
    case "zimmer":
      result = isPlural ? titles.Zimmers : titles.Zimmer;
      break;
    default:
      break;
  }
  return result;
};

export const getPropertyItemTitle = (titles, type, isPlural = false) => {
  let result = titles.Hotel;
  switch (type.toLowerCase()) {
    case "hotel":
      result = isPlural ? titles.Rooms : titles.Room;
      break;
    case "apartment":
      result = isPlural ? titles.Apartments : titles.Apartment;
      break;
    case "hostel":
      result = isPlural ? titles.Rooms : titles.Room;
      break;
    case "zimmer":
      result = isPlural ? titles.Zimmers : titles.Zimmer;
      break;
    default:
      break;
  }
  return result;
};

export const getPropertyRegionsTitle = (titles, type) => {
  let result = titles.Hotel;
  switch (type.toLowerCase()) {
    case "hotel":
      result = titles.InWhichHotelWouldYouLikeToStay;
      break;
    case "apartment":
      result = titles.InWhichApartmentWouldYouLikeToStay;
      break;
    case "hostel":
      result = titles.InWhichHostelWouldYouLikeToStay;
      break;
    case "zimmer":
      result = titles.InWhichZimmerWouldYouLikeToStay;
      break;
    case "apartmentBuilding":
      result = titles.InWhichApartmentBuildingWouldYouLikeToStay;
      break;
    default:
      break;
  }
  return result;
};

export const getPropertyWhichTitle = (titles, type) => {
  let result = titles.Hotel;
  switch (type.toLowerCase()) {
    case "hotel":
      result = titles.Which;
      break;
    case "apartment":
      result = titles.WhichApartment;
      break;
    // case "apartmentbuilding":
    //   result = isPlural ? titles.Apartments : titles.Apartment;
    //   break;
    case "zimmer":
      result = titles.Which;
      break;
    case "hostel":
      result = titles.Which;
      break;
    default:
      break;
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/helpers/general-helpers.js